import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-start-stop-move',
  templateUrl: './start-stop-move.component.html',
  styleUrls: ['./start-stop-move.component.css']
})
export class StartStopMoveComponent implements OnInit {

  message = "Note: An Account Establishment charge will be required and a deposit may be required to establish electric service.";

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/start-stop-move/start-stop-move.component.ts